import styled from '@emotion/styled';
import {
  Typography as TypographyMui,
  TypographyProps as TypographyPropsMui,
} from '@mui/material';

export type TypographyProps = Pick<
  TypographyPropsMui,
  | 'children'
  | 'variant'
  | 'color'
  | 'noWrap'
  | 'component'
  | 'title'
  | 'id'
  | 'fontWeight'
> & {
  readonly underline?: boolean;
  readonly italic?: boolean;
};

const StyledTypography = styled(TypographyMui)<{
  underline?: boolean;
  italic?: boolean;
}>`
  ${({ underline, italic }) =>
    `
    ${
      underline &&
      `
      text-decoration: underline;
      text-decoration-color: currentColor;
    `
    }
    ${
      italic &&
      `
      font-style: italic;
    `
    }
  `}
`;

export function Typography({ ...rest }: TypographyProps) {
  return <StyledTypography {...rest} />;
}
